function handleMobileCookies(setCookieHeader: string | null) {
  // do nothing, placeholder for React web
}

export default handleMobileCookies;
